import { createContext } from 'react';
import noop from 'lodash/noop';

const NowPlayingContext = createContext({ scrollToTop: noop });

export default NowPlayingContext;
